import {Environment} from './environment';

export class EnvironmentLoader {

  static getEnvironmentFile(): any {
    const url = document.location.hostname;
    let dpUrl = '';
    const mockingSet = false;
    const clientId: Map<string, string> = new Map([
      ['auth', '1053'] // need the latest client id
    ]);
    const prodState = true;
    let agentLessToggle= false;
    let envName = 'local';
    let proxyState = false; // False = JBOSS & true = Proxy 45
    let ciamAccountUrl = '';
    let sfdAccountUrl = '';
    let ciamApiSgwUrl = '';

    /* We have to update the URLs below per the new site. */
    if (url.includes('ltd3-gbaccount')) {
     /// dpUrl = 'https://int-api.thehartford.com/uws/';
      dpUrl = 'https://int-api.thehartford.com/';
      envName = 'LTD3';
      ciamAccountUrl = 'https://account-dev.thehartford.com';
      sfdAccountUrl = 'https://ltd3-gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwdev.thehartford.com/';
    } else if (url.includes('ltd-gbaccount')) {
      dpUrl = 'https://int-api.thehartford.com/';
      envName = 'LTD';
      ciamAccountUrl = 'https://account-dev.thehartford.com';
      sfdAccountUrl = 'https://ltd-gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwdev.thehartford.com/';
    } else if (url.includes('dev1-ebaccount')) {
      dpUrl = 'https://int-apis-hig.thehartford.com/';
      envName = 'dev1';
      ciamAccountUrl = 'https://account-dev.thehartford.com';
      sfdAccountUrl = 'https://dev1-ebaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwdev.thehartford.com/';
    } else if (url.includes('lqa-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'lqa';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://lqa-gbaccount.thehartford.com';
      proxyState = false;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
      agentLessToggle= true;
    } else if (url.includes('lqa2-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'lqa2';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://lqa2-gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('lqa3-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'lqa3';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://lqa3-gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('qa3-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'QA3';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://qa3-gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('qa-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'QA';
      agentLessToggle= true;
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://qa-gbaccount.thehartford.com';
      proxyState = false;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('pte-gbaccount')) {
      dpUrl = 'https://qa-api.thehartford.com/';
      envName = 'pte';
      agentLessToggle= true;
      ciamAccountUrl = 'https://account-pte.thehartford.com';
      sfdAccountUrl = 'https://pte-gbaccount.thehartford.com';
      proxyState = false;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('gbaccount')) {
      dpUrl = 'https://APIs-hig.thehartford.com/';
      envName = 'prod';
      ciamAccountUrl = 'https://account.thehartford.com';
      sfdAccountUrl = 'https://gbaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgw.thehartford.com/';
    } else if (url.includes('pt1-ebaccount')) {
      dpUrl = 'https://qa-apis-hig.thehartford.com/';
      envName = 'pt1';
      ciamAccountUrl = 'https://account-pte.thehartford.com';
      sfdAccountUrl = 'https://pt1-ebaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwpse.thehartford.com/';
    } else if (url.includes('sqa1-ebaccount')) {
      dpUrl = 'https://qa-apis-hig.thehartford.com/';
      envName = 'sqa1';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://sqa1-ebaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else if (url.includes('qa1-ebaccount')) {
      dpUrl = 'https://qa-apis-hig.thehartford.com/';
      envName = 'qa1';
      ciamAccountUrl = 'https://account-qa.thehartford.com';
      sfdAccountUrl = 'https://qa1-ebaccount.thehartford.com';
      proxyState = false;
      agentLessToggle= true;
      ciamApiSgwUrl = 'https://ciam-sgwqa.thehartford.com/';
    } else {
      envName = 'local';
      const localCalls = true; // Change this for local dev
      if (localCalls) {
        dpUrl = 'https://int-apis-hig.thehartford.com/';
        envName = 'localhost';
        ciamAccountUrl = 'https://account-dev.thehartford.com';
        sfdAccountUrl = 'http://localhost.thehartford.com:4200';
        proxyState = false;
        agentLessToggle= true;
        ciamApiSgwUrl = 'https://ciam-sgwdev.thehartford.com/'
      }
    }
    return new Environment(clientId, dpUrl, envName, mockingSet, prodState, proxyState, ciamAccountUrl, sfdAccountUrl, ciamApiSgwUrl, agentLessToggle).getEnv();
  }

  static getApiClientId() {
     const url = document.location.hostname;
     const devClientId = '2593df272b30c804dd3dfa820b51c850';
     const ptClientId = '5d8c20ec17c855b7c812a31d848df70a';
     const sqaClientId = '5d8c20ec17c855b7c812a31d848df70a';
     const qaClientId = '5d8c20ec17c855b7c812a31d848df70a';
     const prodClientId = '105222383752d5f342ed2b77f3ab8613';
     if(url.includes('dev1-ebaccount')) {
         return devClientId;     
     } else if(url.includes('pt1-ebaccount')) {
         return ptClientId;     
     } else if(url.includes('sqa1-ebaccount')) {
       return sqaClientId;
     } else if(url.includes('qa1-ebaccount')) {
         return qaClientId;     
    } else if(url.includes('gbaccount')) {
         return prodClientId;
     } else {
         return devClientId;
     }
  }
}
export let env: any = EnvironmentLoader.getEnvironmentFile();
export let envClientId = EnvironmentLoader.getApiClientId();
